/** Bridge 四位协议：bit0 总开关；bit1 BT；bit2 2.4G；bit3 USB。 */
export type BridgeChannel = 'BT' | '2.4G' | 'USB'
export const BRIDGE_CHANNELS: BridgeChannel[] = ['BT', '2.4G', 'USB']
export const BRIDGE_ALL_CHANNELS = 0x0E
const CHANNEL_BITS: Record<BridgeChannel, number> = { BT: 0x02, '2.4G': 0x04, USB: 0x08 }

/** 总开关只修改 bit0，不清空或反转 bit1..3。 */
export function packCallBridgeByte(enabled: boolean, channelMask: number): number {
  if (!Number.isInteger(channelMask) || channelMask < 0 || channelMask > BRIDGE_ALL_CHANNELS || (channelMask & ~BRIDGE_ALL_CHANNELS) !== 0) {
    throw new Error(`Invalid Bridge channel mask: ${channelMask}`)
  }
  return channelMask | (enabled ? 0x01 : 0)
}

export function parseCallBridgeByte(value: number) {
  const raw = value & 0x0F
  return {
    callBridgeByte: raw,
    callBridgeEnabled: raw & 0x01,
    callBridgeChannelMask: raw & BRIDGE_ALL_CHANNELS,
    callBridgeBtEnabled: (raw & 0x02) ? 1 : 0,
    callBridgeDongleEnabled: (raw & 0x04) ? 1 : 0,
    callBridgeUsbEnabled: (raw & 0x08) ? 1 : 0,
  }
}

/** 场景接口为三位通路值：bit0=BT、bit1=2.4G、bit2=USB；0=总关闭。 */
export const SCENE_BRIDGE_ALL_CHANNELS = 0x07

export function validateSceneBridgeValue(value: number): number {
  if (!Number.isInteger(value) || value < 0 || value > SCENE_BRIDGE_ALL_CHANNELS) {
    throw new Error(`Invalid scene callBridgeOnoff: ${value} (expected 0..7)`)
  }
  return value
}

/** 接口没有独立的总开关位；关闭时保留硬件侧的通路配置。 */
export function sceneBridgeToHardwareByte(value: number, disabledChannelMask = 0): number {
  validateSceneBridgeValue(value)
  return packCallBridgeByte(value !== 0, value === 0 ? disabledChannelMask : value << 1)
}

/** 硬件 bit0 为总开关；OFF 统一上报 0，不能把保留通路误报成开启。 */
export function hardwareBridgeToSceneValue(byte: number): number {
  return (byte & 0x01) !== 0 ? (byte & BRIDGE_ALL_CHANNELS) >> 1 : 0
}

export function getBridgeChannels(channelMask: number): BridgeChannel[] {
  return BRIDGE_CHANNELS.filter(channel => (channelMask & CHANNEL_BITS[channel]) !== 0)
}

export function getBridgeChannelMask(channels: readonly BridgeChannel[]): number {
  return channels.reduce((mask, channel) => mask | CHANNEL_BITS[channel], 0)
}
